import { connect } from 'react-redux';
import mobileUserProducts from '../../components/Settings/mobileUserProducts';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';

function mapStateToProps(state) {
  return {
    currentUser: state.settings.currentUser,
    isLoading: state.settings.userDetailIsLoading,
    error: state.settings.userDetailError,
    userPermissions: state.auth.userPermissions,
  };
}

export default connect(mapStateToProps, {
  setDefaultOfForm,
})(mobileUserProducts);



// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/mobileUserProducts.jsx